.root    { display: flex; flex-direction: column; }
.viewRoot { display: flex; flex-direction: column; gap: var(--sp-8); }

/* ── Breadcrumb ───────────────────────────────────────────── */
.breadcrumb { display: flex; align-items: center; gap: var(--sp-1); font-family: var(--font-mono); font-size: 12px; }
.bcParts    { display: flex; align-items: center; gap: var(--sp-1); }
.bcSep      { color: var(--color-text-faint); margin: 0 var(--sp-1); }
.bcLink     { background: none; border: none; color: var(--color-sky); font-family: var(--font-mono); font-size: 12px; cursor: pointer; padding: 0; }
.bcLink:hover { color: var(--color-teal-bright); }
.bcCurrent  { color: var(--color-text-muted); }

/* ── Header ───────────────────────────────────────────────── */
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-6);
  flex-wrap: wrap;
}

.title { font-family: var(--font-mono); font-size: 22px; font-weight: 700; letter-spacing: 0.5px; }
.sub   { font-size: 13px; color: var(--color-text-muted); margin-top: var(--sp-1); }

.headerRight { display: flex; align-items: center; gap: var(--sp-5); flex-shrink: 0; }

.headerStats { display: flex; align-items: center; gap: var(--sp-5); }

.stat      { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; }
.statVal   {
  font-family: var(--font-mono); font-size: 22px; font-weight: 700;
  background: var(--grad-brand);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.statOk    { background: none !important; -webkit-text-fill-color: var(--color-success) !important; }
.statSmall { font-size: 14px !important; }
.statLabel { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.5px; color: var(--color-text-muted); text-transform: uppercase; text-align: right; }
.statDivider { width: 1px; height: 36px; background: var(--color-border); }

/* ── Run button (header) ──────────────────────────────────── */
.runOpenBtn {
  font-family: var(--font-mono); font-size: 12px; font-weight: 700;
  padding: var(--sp-2) var(--sp-5);
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.12);
  border: 1px solid rgba(56, 189, 248, 0.3);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  letter-spacing: 0.5px;
}
.runOpenBtn:hover { background: rgba(56, 189, 248, 0.2); border-color: rgba(56, 189, 248, 0.5); }

/* ── Data Wizard button ───────────────────────────────────── */
.wizardBtn {
  font-family: var(--font-mono); font-size: 11px; font-weight: 700;
  letter-spacing: 0.4px; padding: var(--sp-1) var(--sp-3);
  border-radius: var(--radius-sm);
  background: rgba(139, 92, 246, 0.08);
  border: 1px solid rgba(139, 92, 246, 0.2);
  color: #a78bfa;
  cursor: pointer; transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap; margin-left: auto;
}
.wizardBtn:hover:not(:disabled) {
  background: rgba(139, 92, 246, 0.16); border-color: rgba(139, 92, 246, 0.4); color: #c4b5fd;
}
.wizardBtn:disabled { opacity: 0.5; cursor: default; }
.wizardBtnRunning {
  animation: wizardPulse 1.6s ease-in-out infinite;
  border-color: rgba(56, 189, 248, 0.25); background: rgba(56, 189, 248, 0.08); color: var(--color-sky);
}
.wizardBtnDone {
  border-color: rgba(45, 212, 191, 0.25); background: rgba(45, 212, 191, 0.08);
  color: var(--color-teal-bright); animation: none;
}
.wizardBtnFail {
  border-color: rgba(239, 68, 68, 0.25); background: rgba(239, 68, 68, 0.08);
  color: var(--color-error); animation: none;
}
@keyframes wizardPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.45; } }

/* ── Schedule bar ─────────────────────────────────────────── */
.scheduleBar {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-5);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 13px;
  flex-wrap: wrap;
}
.scheduleIcon { color: var(--color-text-faint); font-size: 14px; }
.scheduleText { color: var(--color-text-muted); }
.scheduleText strong { color: var(--color-text); font-weight: 600; }
.scheduleSep  { color: var(--color-text-faint); }
.scheduleNext { font-family: var(--font-mono); font-size: 12px; color: var(--color-text-faint); }
.scheduleEditBtn {
  margin-left: auto; font-family: var(--font-mono); font-size: 11px;
  padding: 3px 10px; border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border);
  color: var(--color-text-muted); cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}
.scheduleEditBtn:hover { border-color: var(--color-border-med); color: var(--color-text); }

.scheduleEditPanel { display: flex; flex-direction: column; gap: var(--sp-3); width: 100%; }
.scheduleEditLabel {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  letter-spacing: 2px; text-transform: uppercase; color: var(--color-text-muted);
}
.scheduleOptions { display: flex; flex-wrap: wrap; gap: var(--sp-2); }
.scheduleOption {
  display: flex; align-items: center; gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-size: 13px; color: var(--color-text-muted);
  cursor: pointer; transition: border-color 0.15s, background 0.15s;
}
.scheduleOption:has(input:checked) {
  border-color: rgba(56, 189, 248, 0.35);
  background: rgba(56, 189, 248, 0.05);
  color: var(--color-text);
}
.scheduleOption input { accent-color: var(--color-sky); }
.scheduleCron { font-family: var(--font-mono); font-size: 10px; color: var(--color-text-faint); margin-left: var(--sp-1); }
.scheduleActions { display: flex; gap: var(--sp-2); }
.scheduleSaveBtn {
  font-family: var(--font-mono); font-size: 11px; padding: 3px 12px;
  border-radius: var(--radius-sm); background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.25); color: var(--color-sky); cursor: pointer;
  transition: background 0.15s;
}
.scheduleSaveBtn:hover { background: rgba(56, 189, 248, 0.18); }
.scheduleCancelBtn {
  font-family: var(--font-mono); font-size: 11px; padding: 3px 10px;
  border-radius: var(--radius-sm); background: transparent;
  border: 1px solid var(--color-border); color: var(--color-text-faint); cursor: pointer;
}

/* ── Layer cards ──────────────────────────────────────────── */
.layerGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--sp-4);
}
@media (max-width: 900px) { .layerGrid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 520px) { .layerGrid { grid-template-columns: 1fr; } }

.layerCard {
  display: flex; flex-direction: column; gap: var(--sp-3);
  padding: var(--sp-5); background: var(--color-surface);
  border: 1px solid var(--color-border); border-radius: var(--radius-lg);
  text-align: left; cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.layerCard:hover { box-shadow: var(--shadow-glow); }
.layerCard_sky:hover   { border-color: rgba(56, 189, 248, 0.35); }
.layerCard_teal:hover  { border-color: rgba(45, 212, 191, 0.3); }
.layerCard_warn:hover  { border-color: rgba(245, 158, 11, 0.3); }
.layerCard_faint:hover { border-color: var(--color-border-med); }

.layerCardTop { display: flex; align-items: center; justify-content: space-between; }
.layerArrow   { font-size: 16px; color: var(--color-text-faint); }
.layerName    { font-family: var(--font-mono); font-size: 16px; font-weight: 700; color: var(--color-text); }
.layerSubtitle { font-size: 12px; color: var(--color-text-muted); line-height: 1.4; margin-top: -6px; }
.layerMeta    { font-family: var(--font-mono); font-size: 11px; color: var(--color-text-faint); }

/* Layer / schema label badges */
.layerLabel {
  font-family: var(--font-mono); font-size: 9px; font-weight: 700;
  letter-spacing: 2px; padding: 2px 8px; border-radius: 3px;
}
.layerLabel_sky   { background: rgba(56,189,248,0.1);  border: 1px solid rgba(56,189,248,0.2);  color: var(--color-sky); }
.layerLabel_teal  { background: rgba(45,212,191,0.1);  border: 1px solid rgba(45,212,191,0.2);  color: var(--color-teal-bright); }
.layerLabel_warn  { background: rgba(245,158,11,0.1);  border: 1px solid rgba(245,158,11,0.2);  color: var(--color-warn); }
.layerLabel_faint { background: rgba(226,239,248,0.05);border: 1px solid var(--color-border);   color: var(--color-text-faint); }

/* ── Section ──────────────────────────────────────────────── */
.section { display: flex; flex-direction: column; gap: var(--sp-4); }
.sectionHeader { display: flex; align-items: baseline; gap: var(--sp-4); }
.sectionLabel {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  letter-spacing: 2px; text-transform: uppercase; color: var(--color-text-muted);
}
.sectionHint { font-size: 11px; color: var(--color-text-faint); }

/* ── Connector group ──────────────────────────────────────── */
.connectorGroupLabel {
  display: flex; align-items: center; gap: var(--sp-2);
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  color: var(--color-text-muted); letter-spacing: 0.3px;
}
.connectorDot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--color-sky-dim); flex-shrink: 0;
}

/* ── KPI cards ────────────────────────────────────────────── */
.kpiGrid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: var(--sp-4); }
.kpiCard {
  background: var(--color-surface); border: 1px solid var(--color-border);
  border-radius: var(--radius-md); padding: var(--sp-4) var(--sp-5);
  display: flex; flex-direction: column; gap: var(--sp-2);
  transition: border-color 0.2s;
}
.kpiCard:hover { border-color: var(--color-border-med); }
.kpiTop { display: flex; align-items: center; justify-content: space-between; gap: var(--sp-3); }
.kpiName { font-family: var(--font-mono); font-size: 13px; font-weight: 700; color: var(--color-text); }
.kpiOwner {
  font-family: var(--font-mono); font-size: 10px; padding: 2px 6px;
  border-radius: 3px; background: rgba(56,189,248,0.07);
  border: 1px solid var(--color-border); color: var(--color-text-faint); white-space: nowrap;
}
.kpiDesc   { font-size: 12px; color: var(--color-text-muted); line-height: 1.5; }
.kpiFormula {
  font-family: var(--font-mono); font-size: 11px; color: var(--color-teal-bright);
  background: rgba(45,212,191,0.05); border: 1px solid rgba(45,212,191,0.12);
  border-radius: var(--radius-sm); padding: var(--sp-2) var(--sp-3);
}
.kpiSource { font-family: var(--font-mono); font-size: 10px; color: var(--color-text-faint); }

/* ── Table ────────────────────────────────────────────────── */
.table { width: 100%; border-collapse: collapse; font-size: 13px; }
.table thead tr { border-bottom: 1px solid var(--color-border-med); }
.table th {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  letter-spacing: 1.5px; color: var(--color-text-faint); text-transform: uppercase;
  text-align: left; padding: var(--sp-2) var(--sp-3);
}
.table td { padding: var(--sp-3); border-bottom: 1px solid var(--color-border); vertical-align: middle; }
.table tbody tr:last-child td { border-bottom: none; }
.tableRow { cursor: pointer; transition: background 0.15s; }
.tableRow:hover td { background: rgba(56,189,248,0.03); }
.arrowCell { color: var(--color-text-faint); font-size: 14px; text-align: right; width: 24px; }
.modelName { font-family: var(--font-mono); font-size: 13px; font-weight: 600; color: var(--color-text); }
.colName   { font-family: var(--font-mono); font-size: 12px; color: var(--color-text); }
.sourceTag {
  font-family: var(--font-mono); font-size: 10px; padding: 2px 7px; border-radius: 3px;
  background: rgba(56,189,248,0.07); border: 1px solid var(--color-border);
  color: var(--color-text-faint); white-space: nowrap;
}
.typeBadge {
  font-family: var(--font-mono); font-size: 10px; padding: 2px 6px; border-radius: 3px;
  background: var(--color-surface-2); border: 1px solid var(--color-border);
  color: var(--color-text-muted);
}
.mono      { font-family: var(--font-mono); font-size: 12px; color: var(--color-text-muted); }
.monoMuted { font-family: var(--font-mono); font-size: 12px; color: var(--color-text-faint); }

/* ── Tests ────────────────────────────────────────────────── */
.testPill { font-family: var(--font-mono); font-size: 10px; font-weight: 600; padding: 2px 7px; border-radius: 3px; white-space: nowrap; }
.testPillPass { background: rgba(34,197,94,0.08);  border: 1px solid rgba(34,197,94,0.2);  color: var(--color-success); }
.testPillFail { background: rgba(239,68,68,0.08);  border: 1px solid rgba(239,68,68,0.2);  color: var(--color-error); }
.testTags     { display: flex; flex-wrap: wrap; gap: 4px; }
.testTag { font-family: var(--font-mono); font-size: 10px; padding: 1px 6px; border-radius: 3px; background: rgba(56,189,248,0.06); border: 1px solid var(--color-border); color: var(--color-text-faint); }

/* ── Table detail ─────────────────────────────────────────── */
.detailHeader { display: flex; align-items: flex-start; justify-content: space-between; gap: var(--sp-8); flex-wrap: wrap; }
.detailLeft   { flex: 1; display: flex; flex-direction: column; gap: var(--sp-3); }
.detailTop    { display: flex; align-items: center; gap: var(--sp-4); flex-wrap: wrap; }
.detailStats  { display: flex; align-items: center; gap: var(--sp-5); flex-shrink: 0; }
.detailDesc   { font-size: 13px; color: var(--color-text-muted); line-height: 1.6; flex: 1; }
.descCell     { min-width: 220px; }
.descRow      { display: flex; align-items: center; gap: var(--sp-3); }
.colDesc      { font-size: 12px; color: var(--color-text-muted); flex: 1; }
.noDesc       { color: var(--color-text-faint); font-style: italic; }
.descEdit     { display: flex; flex-direction: column; gap: var(--sp-2); }
.descTextarea, .descInput {
  width: 100%; padding: var(--sp-2) var(--sp-3);
  background: var(--color-surface-2); border: 1px solid var(--color-border-med);
  border-radius: var(--radius-sm); color: var(--color-text); font-size: 12px;
  outline: none; resize: vertical;
}
.descTextarea:focus, .descInput:focus { border-color: rgba(56,189,248,0.4); }
.descActions { display: flex; gap: var(--sp-2); }

.editBtn {
  font-family: var(--font-mono); font-size: 10px; padding: 2px 8px;
  border-radius: var(--radius-sm); background: transparent;
  border: 1px solid var(--color-border); color: var(--color-text-faint);
  cursor: pointer; white-space: nowrap; transition: border-color 0.15s, color 0.15s;
}
.editBtn:hover { border-color: var(--color-border-med); color: var(--color-text-muted); }
.saveBtn {
  font-family: var(--font-mono); font-size: 10px; padding: 2px 8px;
  border-radius: var(--radius-sm); background: rgba(56,189,248,0.1);
  border: 1px solid rgba(56,189,248,0.25); color: var(--color-sky); cursor: pointer;
}
.saveBtn:hover { background: rgba(56,189,248,0.18); }
.cancelBtn {
  font-family: var(--font-mono); font-size: 10px; padding: 2px 8px;
  border-radius: var(--radius-sm); background: transparent;
  border: 1px solid var(--color-border); color: var(--color-text-faint); cursor: pointer;
}
.savedMsg { font-family: var(--font-mono); font-size: 11px; color: var(--color-success); white-space: nowrap; }

.renameBtn {
  font-family: var(--font-mono); font-size: 10px; padding: 2px 8px;
  border-radius: var(--radius-sm); background: transparent;
  border: 1px solid var(--color-border); color: var(--color-text-faint);
  cursor: pointer; white-space: nowrap; transition: border-color 0.15s, color 0.15s;
}
.renameBtn:hover { border-color: var(--color-border-med); color: var(--color-text-muted); }
.renameRow { display: flex; align-items: center; gap: var(--sp-2); flex-wrap: wrap; }
.renameInput {
  font-family: var(--font-mono); font-size: 14px; font-weight: 600;
  padding: 3px var(--sp-2); background: var(--color-surface-2);
  border: 1px solid rgba(56,189,248,0.4); border-radius: var(--radius-sm);
  color: var(--color-text); outline: none; min-width: 200px;
}

/* ── Test summary ─────────────────────────────────────────── */
.testSummaryBox {
  display: flex; align-items: center; gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-5); border-radius: var(--radius-md);
  font-family: var(--font-mono); font-size: 13px; font-weight: 600;
}
.testSummaryPass { background: rgba(34,197,94,0.07); border: 1px solid rgba(34,197,94,0.18); color: var(--color-success); }
.testSummaryFail { background: rgba(239,68,68,0.07); border: 1px solid rgba(239,68,68,0.18); color: var(--color-error); }
.testSummaryText { font-size: 12px; font-weight: 400; color: var(--color-text-muted); }
.testBreakdown { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-md); overflow: hidden; }
.testBreakdownRow { display: flex; align-items: center; gap: var(--sp-4); padding: var(--sp-2) var(--sp-4); border-bottom: 1px solid var(--color-border); }
.testBreakdownRow:last-child { border-bottom: none; }
.testBreakdownCol { font-family: var(--font-mono); font-size: 12px; color: var(--color-text-muted); width: 200px; flex-shrink: 0; }

/* ── Seeds upload ─────────────────────────────────────────── */
.uploadArea {
  display: flex; align-items: center; gap: var(--sp-4); flex-wrap: wrap;
  padding: var(--sp-4) var(--sp-5);
  background: var(--color-surface); border: 1px dashed var(--color-border-med);
  border-radius: var(--radius-md);
}
.fileInput { display: none; }
.fileLabel {
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.08); border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky); cursor: pointer; transition: background 0.15s;
}
.fileLabel:hover { background: rgba(56,189,248,0.15); }
.uploadBtn {
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
  background: rgba(45,212,191,0.1); border: 1px solid rgba(45,212,191,0.25);
  color: var(--color-teal-bright); cursor: pointer; transition: background 0.15s;
}
.uploadBtn:hover:not(:disabled) { background: rgba(45,212,191,0.18); }
.uploadBtn:disabled { opacity: 0.45; cursor: default; }
.uploadHint    { font-size: 12px; color: var(--color-text-faint); }
.uploadSuccess { font-size: 12px; color: var(--color-success); }
.uploadError   { font-size: 12px; color: var(--color-error); }

/* ── Run dbt modal ────────────────────────────────────────── */
.overlay {
  position: fixed; inset: 0;
  background: rgba(4,13,24,0.85); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center;
  padding: var(--sp-4); z-index: 300;
}
.runModal {
  width: 100%; max-width: 560px;
  background: var(--color-surface); border: 1px solid var(--color-border-med);
  border-radius: var(--radius-lg); box-shadow: var(--shadow-strong);
  display: flex; flex-direction: column; overflow: hidden;
}
.runModalHeader {
  display: flex; align-items: center; justify-content: space-between;
  padding: var(--sp-4) var(--sp-6); border-bottom: 1px solid var(--color-border);
}
.runModalTitle { font-family: var(--font-mono); font-size: 14px; font-weight: 700; }
.closeBtn {
  background: none; border: none; color: var(--color-text-muted); font-size: 16px;
  cursor: pointer; padding: 2px 6px; border-radius: var(--radius-sm);
  transition: color 0.15s, background 0.15s;
}
.closeBtn:hover { color: var(--color-text); background: rgba(255,255,255,0.05); }

.runModalBody { display: flex; flex-direction: column; gap: var(--sp-5); padding: var(--sp-5) var(--sp-6); }

.runSection { display: flex; flex-direction: column; gap: var(--sp-2); }
.runSectionLabel { font-family: var(--font-mono); font-size: 10px; font-weight: 600; letter-spacing: 2px; text-transform: uppercase; color: var(--color-text-muted); margin-bottom: var(--sp-1); }

.radioRow { display: flex; align-items: center; gap: var(--sp-3); font-size: 13px; color: var(--color-text-muted); cursor: pointer; }
.radioRow input { accent-color: var(--color-sky); }

.tagChips { display: flex; gap: var(--sp-2); margin-top: var(--sp-2); margin-left: var(--sp-6); }
.tagChip {
  font-family: var(--font-mono); font-size: 11px; font-weight: 600;
  padding: 3px 12px; border-radius: 20px;
  border: 1px solid var(--color-border); background: transparent;
  color: var(--color-text-muted); cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
}
.tagChipOn {
  background: rgba(56,189,248,0.1); border-color: rgba(56,189,248,0.35); color: var(--color-sky);
}

.cmdPreview {
  display: flex; gap: var(--sp-2); align-items: center;
  padding: var(--sp-3) var(--sp-4);
  background: var(--color-surface-2); border: 1px solid var(--color-border);
  border-radius: var(--radius-sm); font-family: var(--font-mono); font-size: 12px;
}
.cmdPrompt { color: var(--color-teal-bright); }
.cmdText   { color: var(--color-text-muted); }

.runBtn {
  align-self: stretch; font-family: var(--font-mono); font-size: 13px; font-weight: 700;
  padding: var(--sp-3); border-radius: var(--radius-md);
  background: linear-gradient(135deg, rgba(56,189,248,0.15) 0%, rgba(13,148,136,0.15) 100%);
  border: 1px solid rgba(56,189,248,0.3); color: var(--color-sky);
  cursor: pointer; transition: background 0.15s, border-color 0.15s;
}
.runBtn:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(56,189,248,0.22) 0%, rgba(13,148,136,0.22) 100%);
  border-color: rgba(56,189,248,0.5);
}
.runBtn:disabled { opacity: 0.4; cursor: default; }

.runningBanner {
  display: flex; align-items: center; gap: var(--sp-3);
  font-family: var(--font-mono); font-size: 12px; color: var(--color-text-muted);
}
.runSpinner {
  width: 14px; height: 14px; border: 2px solid var(--color-border-med);
  border-top-color: var(--color-sky); border-radius: 50%;
  animation: spin 0.8s linear infinite; flex-shrink: 0;
}
@keyframes spin { to { transform: rotate(360deg); } }

.runResultBanner {
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
}
.runResultPass { background: rgba(34,197,94,0.08); border: 1px solid rgba(34,197,94,0.2); color: var(--color-success); }
.runResultFail { background: rgba(239,68,68,0.08); border: 1px solid rgba(239,68,68,0.2); color: var(--color-error); }

.runLog {
  background: #020810; border: 1px solid var(--color-border);
  border-radius: var(--radius-sm); padding: var(--sp-3) var(--sp-4);
  font-family: var(--font-mono); font-size: 11px; line-height: 1.7;
  max-height: 260px; overflow-y: auto; color: var(--color-text-faint);
}
.logLine   { white-space: pre; }
.logOk     { color: var(--color-success); }
.logErr    { color: var(--color-error); }
.logCursor { color: var(--color-sky); animation: blink 1s step-end infinite; }
@keyframes blink { 50% { opacity: 0; } }

.runModalFooter { display: flex; align-items: center; gap: var(--sp-3); }
.runAgainBtn {
  font-family: var(--font-mono); font-size: 11px; padding: var(--sp-2) var(--sp-4);
  border-radius: var(--radius-sm); background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.2); color: var(--color-sky); cursor: pointer;
}
.closeLinkBtn {
  font-family: var(--font-mono); font-size: 11px; padding: var(--sp-2) var(--sp-3);
  background: transparent; border: 1px solid var(--color-border);
  border-radius: var(--radius-sm); color: var(--color-text-faint); cursor: pointer;
}

/* ── Refresh status bar ───────────────────────────────────── */
.statusBar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 16px; border-radius: var(--radius-sm); margin-bottom: var(--sp-4);
  font-family: var(--font-mono); font-size: 12px;
}
.statusBarRunning { background: rgba(56,189,248,0.08); border: 1px solid rgba(56,189,248,0.2); color: var(--color-sky); }
.statusBarDone    { background: rgba(52,211,153,0.08); border: 1px solid rgba(52,211,153,0.2); color: #34d399; }
.statusBarFailed  { background: rgba(248,113,113,0.08); border: 1px solid rgba(248,113,113,0.2); color: #f87171; }
.statusBarMsg { display: flex; align-items: center; gap: 8px; }
.statusBarActions { display: flex; align-items: center; gap: 8px; }
.statusBarFixBtn {
  background: rgba(248,113,113,0.15); border: 1px solid rgba(248,113,113,0.35);
  border-radius: 4px; cursor: pointer; color: #f87171; font-size: 11px; font-weight: 600;
  padding: 3px 8px;
}
.statusBarFixBtn:hover { background: rgba(248,113,113,0.25); }
.statusBarDismiss {
  background: transparent; border: none; cursor: pointer; opacity: 0.5; font-size: 11px;
  padding: 0 2px; color: inherit;
}
.statusBarDismiss:hover { opacity: 1; }
.statusSpinner {
  display: inline-block; width: 10px; height: 10px; border-radius: 50%;
  border: 1.5px solid currentColor; border-top-color: transparent;
  animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.startErr { font-family: var(--font-mono); font-size: 11px; color: #f87171; }

/* ── Sensitivity & classification badges ──────────────────── */
.colBadges { display: flex; gap: 4px; flex-wrap: wrap; align-items: center; }

.sensitivityBadge {
  font-family: var(--font-mono); font-size: 9px; font-weight: 700;
  letter-spacing: 0.06em; text-transform: uppercase;
  padding: 2px 7px; border-radius: 3px; white-space: nowrap;
}
.sensitivityBadge_high   { background: rgba(239,68,68,0.1);  border: 1px solid rgba(239,68,68,0.3);  color: #f87171; }
.sensitivityBadge_medium { background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.3); color: var(--color-warn); }

.classificationBadge {
  font-family: var(--font-mono); font-size: 9px; font-weight: 500;
  padding: 2px 7px; border-radius: 3px; white-space: nowrap;
  background: rgba(148,163,184,0.08); border: 1px solid var(--color-border);
  color: var(--color-text-faint);
}

.docsBadge {
  font-family: var(--font-mono); font-size: 9px; font-weight: 600;
  letter-spacing: 0.04em; text-transform: uppercase;
  padding: 2px 7px; border-radius: 3px; white-space: nowrap;
  background: rgba(45,212,191,0.08); border: 1px solid rgba(45,212,191,0.2);
  color: var(--color-teal-bright);
}
.docsBadgeMissing {
  font-family: var(--font-mono); font-size: 9px; font-weight: 600;
  letter-spacing: 0.04em; text-transform: uppercase;
  padding: 2px 7px; border-radius: 3px; white-space: nowrap;
  background: rgba(245,158,11,0.08); border: 1px solid rgba(245,158,11,0.2);
  color: var(--color-warn);
}
.chartBadge {
  display: inline-block;
  margin-left: 7px;
  font-family: var(--font-mono); font-size: 9px;
  padding: 2px 6px; border-radius: 3px; white-space: nowrap;
  max-width: 160px; overflow: hidden; text-overflow: ellipsis;
  vertical-align: middle;
  background: rgba(6,182,212,0.08); border: 1px solid rgba(6,182,212,0.2);
  color: #06b6d4;
}

/* ── Column inline edit form ──────────────────────────────── */
.colEditForm { display: flex; flex-direction: column; gap: var(--sp-2); padding: var(--sp-1) 0; }

.fieldRow {
  display: flex; align-items: center; gap: var(--sp-3);
}
.fieldLabel {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  letter-spacing: 0.08em; text-transform: uppercase; color: var(--color-text-muted);
  min-width: 80px; flex-shrink: 0;
}
.fieldSelect {
  background: var(--color-surface-2); border: 1px solid var(--color-border-med);
  color: var(--color-text); border-radius: var(--radius-sm);
  padding: 3px 8px; font-size: 12px; font-family: var(--font-mono);
  cursor: pointer; outline: none;
}
.fieldSelect:focus { border-color: rgba(56,189,248,0.4); }

.saveErrMsg {
  font-family: var(--font-mono); font-size: 11px; color: var(--color-error);
}

.emptyState {
  padding: var(--sp-8) var(--sp-4);
  text-align: center;
  font-family: var(--font-mono); font-size: 12px;
  color: var(--color-text-faint);
  border: 1px dashed var(--color-border);
  border-radius: var(--radius);
}

.loadingMsg {
  padding: var(--sp-12) var(--sp-4);
  text-align: center;
  font-family: var(--font-mono); font-size: 12px;
  color: var(--color-text-faint);
}

/* ── Chat upload prompt ───────────────────────────────────── */
.chatUploadPrompt {
  display: flex; align-items: center; gap: var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
  background: var(--color-surface); border: 1px solid var(--color-border);
  border-radius: var(--radius-md); margin-bottom: var(--sp-4);
}
.chatUploadIcon {
  font-size: 22px; color: var(--color-sky); flex-shrink: 0; opacity: 0.8;
}
.chatUploadTitle {
  font-family: var(--font-mono); font-size: 13px; font-weight: 600; color: var(--color-text);
}
.chatUploadSub { font-size: 12px; color: var(--color-text-muted); margin-top: 2px; }
.chatUploadBtn {
  margin-left: auto; flex-shrink: 0;
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.08); border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky); cursor: pointer; transition: background 0.15s;
}
.chatUploadBtn:hover { background: rgba(56,189,248,0.15); }

/* ── Direct CSV upload button ─────────────────────────────── */
.uploadBtn {
  font-family: var(--font-mono); font-size: 12px; font-weight: 600;
  padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
  background: rgba(245,158,11,0.08); border: 1px solid rgba(245,158,11,0.25);
  color: var(--color-warn); cursor: pointer; transition: background 0.15s;
}
.uploadBtn:hover:not(:disabled) { background: rgba(245,158,11,0.15); }
.uploadBtn:disabled { opacity: 0.5; cursor: default; }

.uploadErrBanner {
  font-family: var(--font-mono); font-size: 12px; color: var(--color-error);
  background: rgba(239,68,68,0.08); border: 1px solid rgba(239,68,68,0.2);
  border-radius: var(--radius-sm); padding: var(--sp-2) var(--sp-4);
  margin-bottom: var(--sp-3);
}

.uploadOkBanner {
  font-family: var(--font-mono); font-size: 12px; color: var(--color-teal-bright);
  background: rgba(45,212,191,0.08); border: 1px solid rgba(45,212,191,0.2);
  border-radius: var(--radius-sm); padding: var(--sp-2) var(--sp-4);
  margin-bottom: var(--sp-3);
}

.conflictDialog {
  background: rgba(251,191,36,0.06); border: 1px solid rgba(251,191,36,0.25);
  border-radius: var(--radius-sm); padding: var(--sp-3) var(--sp-4);
  margin-bottom: var(--sp-3); display: flex; flex-direction: column; gap: var(--sp-2);
}
.conflictMsg {
  font-size: 13px; color: var(--color-text);
}
.conflictMsg strong { color: var(--color-sky); }
.conflictActions {
  display: flex; align-items: center; gap: var(--sp-2); flex-wrap: wrap;
}
.conflictReplace {
  font-size: 12px; font-weight: 600; padding: 5px 14px; border-radius: var(--radius-sm);
  border: 1px solid rgba(239,68,68,0.4); background: rgba(239,68,68,0.08);
  color: var(--color-error); cursor: pointer;
}
.conflictReplace:hover { background: rgba(239,68,68,0.15); }
.conflictVersion {
  font-size: 12px; font-weight: 600; padding: 5px 14px; border-radius: var(--radius-sm);
  border: 1px solid rgba(56,189,248,0.3); background: rgba(56,189,248,0.07);
  color: var(--color-sky); cursor: pointer;
}
.conflictVersion:hover { background: rgba(56,189,248,0.14); }
.conflictVersion code { font-family: var(--font-mono); font-size: 11px; }

/* ── Definition job status badges ─────────────────────────── */
.docBadge {
  display: inline-block; margin-left: 8px;
  font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: 0.06em;
  text-transform: uppercase; padding: 2px 7px; border-radius: 3px;
  background: rgba(56,189,248,0.08); border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky);
  animation: docPulse 1.6s ease-in-out infinite;
}
@keyframes docPulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.45; }
}

.docBadgeDone {
  display: inline-block; margin-left: 8px;
  font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: 0.06em;
  text-transform: uppercase; padding: 2px 7px; border-radius: 3px;
  background: rgba(45,212,191,0.08); border: 1px solid rgba(45,212,191,0.2);
  color: var(--color-teal-bright);
}

.docBadgeFail {
  display: inline-block; margin-left: 8px;
  font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: 0.06em;
  text-transform: uppercase; padding: 2px 7px; border-radius: 3px;
  background: rgba(239,68,68,0.08); border: 1px solid rgba(239,68,68,0.2);
  color: var(--color-error);
}

/* ── Delete controls ──────────────────────────────────────── */
.deleteCell { white-space: nowrap; text-align: right; padding-right: var(--sp-2) !important; }

.deleteBtn {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600; letter-spacing: 0.05em;
  padding: 2px 8px; border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border);
  color: var(--color-text-faint); cursor: pointer; opacity: 0;
  transition: opacity 0.15s, color 0.15s, border-color 0.15s;
}
tr:hover .deleteBtn { opacity: 1; }
.deleteBtn:hover { color: var(--color-error); border-color: rgba(239,68,68,0.4); }

.confirmDeleteBtn {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  padding: 2px 8px; border-radius: var(--radius-sm);
  background: rgba(239,68,68,0.12); border: 1px solid rgba(239,68,68,0.35);
  color: var(--color-error); cursor: pointer; margin-right: 4px;
  transition: background 0.15s;
}
.confirmDeleteBtn:hover:not(:disabled) { background: rgba(239,68,68,0.2); }
.confirmDeleteBtn:disabled { opacity: 0.5; cursor: default; }

.cancelDeleteBtn {
  font-family: var(--font-mono); font-size: 10px;
  padding: 2px 8px; border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border);
  color: var(--color-text-muted); cursor: pointer;
  transition: color 0.15s;
}
.cancelDeleteBtn:hover { color: var(--color-text); }

/* ── Seed environment badges ──────────────────────────────── */
.envBadgeStaged {
  font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: 0.06em;
  text-transform: uppercase; padding: 2px 7px; border-radius: 3px;
  background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.2);
  color: var(--color-warn); white-space: nowrap;
}

.envBadgeProd {
  font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: 0.06em;
  text-transform: uppercase; padding: 2px 7px; border-radius: 3px;
  background: rgba(45,212,191,0.08); border: 1px solid rgba(45,212,191,0.2);
  color: var(--color-teal-bright); white-space: nowrap;
}

/* ── Seed promotion banner ────────────────────────────────── */
.stageBanner {
  display: flex; align-items: center; justify-content: space-between; gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-4); border-radius: var(--radius-sm);
  background: rgba(245,158,11,0.06); border: 1px solid rgba(245,158,11,0.18);
  margin-bottom: var(--sp-4);
}

.prodBanner {
  display: flex; align-items: center; gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-4); border-radius: var(--radius-sm);
  background: rgba(45,212,191,0.06); border: 1px solid rgba(45,212,191,0.18);
  margin-bottom: var(--sp-4);
}

.bannerLeft { display: flex; align-items: center; gap: var(--sp-3); }

.bannerMsg { font-size: 13px; color: var(--color-text-muted); }

.promoteBtn {
  font-family: var(--font-mono); font-size: 11px; font-weight: 700; letter-spacing: 0.05em;
  text-transform: uppercase; padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
  background: rgba(45,212,191,0.1); border: 1px solid rgba(45,212,191,0.3);
  color: var(--color-teal-bright); cursor: pointer; white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}
.promoteBtn:hover:not(:disabled) { background: rgba(45,212,191,0.18); border-color: rgba(45,212,191,0.5); }
.promoteBtn:disabled { opacity: 0.4; cursor: default; }

/* ── Metric cards (KPI definitions) ──────────────────────── */
.metricGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--sp-3);
}

.metricCard {
  background: var(--color-surface-raised);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.metricTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
}

.metricLabel {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.metricUnit {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-cyan-bright);
  background: rgba(6,182,212,0.1);
  border: 1px solid rgba(6,182,212,0.2);
  border-radius: var(--radius-sm);
  padding: 2px 6px;
}

.metricDesc {
  font-size: 12px;
  color: var(--color-text-muted);
  line-height: 1.5;
  margin: 0;
}

.metricMeta {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  flex-wrap: wrap;
}

.metricModel {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-sky-bright);
  background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.15);
  border-radius: var(--radius-sm);
  padding: 2px 7px;
}

.metricGrain {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  background: rgba(148,163,184,0.07);
  border: 1px solid rgba(148,163,184,0.12);
  border-radius: var(--radius-sm);
  padding: 2px 6px;
}

.metricCalc {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-faint);
  background: rgba(15,23,42,0.6);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: var(--sp-2) var(--sp-3);
  display: block;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

/* ── Compiled SQL viewer ──────────────────────────────────── */
.sqlBlock {
  font-family: var(--font-mono);
  font-size: 12px;
  line-height: 1.6;
  color: #CBD5E1;
  background: rgba(15,23,42,0.75);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-4) var(--sp-5);
  overflow-x: auto;
  white-space: pre;
  margin: 0;
  max-height: 480px;
  overflow-y: auto;
}

:global([data-theme="light"]) .sqlBlock {
  color: #1E3A5F;
  background: #F0F6FB;
}

.sqlLoading {
  font-size: 12px;
  color: var(--color-text-faint);
  padding: var(--sp-3) 0;
}

.sqlEmpty {
  font-size: 13px;
  color: var(--color-text-faint);
  padding: var(--sp-3) 0;
  font-style: italic;
}

/* ── PDF upload flow ──────────────────────────────────────── */

.sectionTitle {
  font-family: var(--font-mono);
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0 0 var(--sp-1);
}
.sectionSub {
  font-size: 13px;
  color: var(--color-text-muted);
  margin: 0;
}

.pdfDropZone {
  border: 2px dashed var(--color-border-med);
  border-radius: var(--radius-md);
  padding: var(--sp-10) var(--sp-6);
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-2);
}
.pdfDropZone:hover {
  border-color: rgba(56, 189, 248, 0.45);
  background: rgba(56, 189, 248, 0.03);
}
.pdfDropIcon {
  font-size: 28px;
  color: var(--color-text-faint);
  line-height: 1;
}
.pdfDropTitle {
  font-family: var(--font-mono);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-muted);
}
.pdfDropSub {
  font-size: 12px;
  color: var(--color-text-faint);
}

.pdfProgressPanel {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-5) var(--sp-6);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.pdfProgressTitle {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-muted);
}
.pdfProgressItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}
.pdfProgressFile { color: var(--color-text-muted); }
.pdfProgressPending { color: var(--color-text-faint); font-style: italic; }
.pdfProgressDone    { color: var(--color-success); font-family: var(--font-mono); font-size: 12px; }
.pdfProgressFail    { color: var(--color-error);   font-family: var(--font-mono); font-size: 12px; }
.pdfProgressNote {
  font-size: 11px;
  color: var(--color-text-faint);
  margin-top: var(--sp-1);
}

.pdfConflictBanner {
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.25);
  border-radius: var(--radius-md);
  padding: var(--sp-3) var(--sp-4);
  font-size: 13px;
  color: var(--color-warn);
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}
.pdfConflictIcon { font-size: 15px; flex-shrink: 0; }
.pdfConflictTag {
  display: inline-block;
  font-size: 9px;
  font-family: var(--font-mono);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.25);
  color: var(--color-warn);
  border-radius: 3px;
  padding: 1px 5px;
  margin-left: var(--sp-2);
  vertical-align: middle;
}

.pdfSchemaHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-6);
  flex-wrap: wrap;
}
.pdfCommitRow {
  display: flex;
  align-items: flex-end;
  gap: var(--sp-3);
  flex-shrink: 0;
  flex-wrap: wrap;
}
.pdfAppendToggle {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
}
.pdfAppendLabel {
  font-size: 13px;
  color: var(--text-2);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.pdfTableNameGroup {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
}
.pdfTableNameLabel {
  font-size: 11px;
  font-family: var(--font-mono);
  color: var(--color-text-faint);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.pdfTableNameInput {
  font-family: var(--font-mono);
  font-size: 13px;
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: var(--sp-2) var(--sp-3);
  color: var(--color-text);
  width: 220px;
  transition: border-color 0.12s;
}
.pdfTableNameInput:focus { outline: none; border-color: rgba(56, 189, 248, 0.5); }
.pdfTableNameInputErr { border-color: var(--color-error) !important; }
.pdfTableNameErrMsg { font-size: 11px; color: var(--color-error); }

.pdfColNameInput {
  font-family: var(--font-mono);
  font-size: 12px;
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: var(--sp-1) var(--sp-2);
  color: var(--color-text);
  width: 160px;
  transition: border-color 0.12s;
}
.pdfColNameInput:focus { outline: none; border-color: rgba(56, 189, 248, 0.5); }
.pdfColNameInput:disabled { opacity: 0.4; cursor: default; }

.pdfTypeSelect {
  font-family: var(--font-mono);
  font-size: 12px;
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: var(--sp-1) var(--sp-2);
  color: var(--color-text);
  width: 100px;
}
.pdfTypeSelect:disabled { opacity: 0.4; cursor: default; }

.pdfRowExcluded { opacity: 0.4; }

.pdfSampleData {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-3) var(--sp-4);
}
.pdfSampleSummary {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-faint);
  cursor: pointer;
  user-select: none;
}
.pdfSampleSummary:hover { color: var(--color-text-muted); }

.pdfDoneLink {
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  color: var(--color-sky);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.pdfDoneLink:hover { color: var(--color-text); }
